__turbopack_context__.v({
  "column": "_8fBucG_column",
  "counter": "_8fBucG_counter",
  "glyph": "_8fBucG_glyph",
  "label": "_8fBucG_label",
  "labelSwap": "_8fBucG_labelSwap",
  "labelText": "_8fBucG_labelText",
  "sizer": "_8fBucG_sizer",
  "srOnly": "_8fBucG_srOnly",
  "symbol": "_8fBucG_symbol",
  "value": "_8fBucG_value",
});
